module.exports = __webpack_public_path__ + "img/coupon-5-fill.2980bf53.svg";